import { TUser } from "@/models/user.model";
import { USER_STATUS_ACTIVE, USER_STATUS_PENDING_INVITE } from "@icebergeradmin/common";

export const getUserStatusName = (status: number) => {
    switch (status) {
        case USER_STATUS_ACTIVE:
            return "Active";
        case USER_STATUS_PENDING_INVITE:
            return "Pending Invite";
        default:
            return "Unknown status";
    }
};

// Sort users by first name ascending
export const sortUsers = (users: TUser[]) => [...users].sort((a, b) => a.firstName?.localeCompare(b?.firstName));